import { render, staticRenderFns } from "./MatchPicker.vue?vue&type=template&id=18793797&scoped=true"
import script from "./MatchPicker.vue?vue&type=script&lang=js"
export * from "./MatchPicker.vue?vue&type=script&lang=js"
import style0 from "./MatchPicker.vue?vue&type=style&index=0&id=18793797&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18793797",
  null
  
)

export default component.exports